// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","header":"App_header__2L3DO","results":"App_results__3F50G","loading":"App_loading__3Rsj5"};